const NoProgressReports = () => {
  return (
    <svg viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Clipboard body */}
      <rect
        x="20"
        y="16"
        width="60"
        height="68"
        rx="4"
        fill="#f0f5fb"
        stroke="#5b8fc4"
        strokeWidth="1.5"
      />

      {/* Clipboard clip */}
      <rect x="42" y="10" width="16" height="8" rx="2" fill="#5b8fc4" />
      <circle cx="43" cy="14" r="1.5" fill="#ffffff" />
      <circle cx="55" cy="14" r="1.5" fill="#ffffff" />

      {/* Chart bars */}
      <rect
        x="30"
        y="45"
        width="6"
        height="20"
        rx="1"
        fill="#a4c4ff"
        opacity="0.5"
      />
      <rect
        x="42"
        y="38"
        width="6"
        height="27"
        rx="1"
        fill="#5b8fc4"
        opacity="0.6"
      />
      <rect
        x="54"
        y="42"
        width="6"
        height="23"
        rx="1"
        fill="#8fb3e3"
        opacity="0.5"
      />

      {/* Empty chart baseline */}
      <line
        x1="28"
        y1="67"
        x2="62"
        y2="67"
        stroke="#c5d3e0"
        strokeWidth="1"
        strokeDasharray="2,2"
      />

      {/* Search/Not found symbol - circle with slash */}
      <circle
        cx="75"
        cy="50"
        r="16"
        fill="none"
        stroke="#d97e6a"
        strokeWidth="2"
        opacity="0.7"
      />
      <line
        x1="62"
        y1="63"
        x2="88"
        y2="37"
        stroke="#d97e6a"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.7"
      />
    </svg>
  );
};

export default NoProgressReports;
